import { useTranslate } from '@festina-life/ui/hooks'
import type { PropsWithChildren } from 'react'

import { useComponent, useHook } from '../../../lenteHooks'
import { IdToPerson } from '../../idToLec/IdToPerson'
import { OverviewItem } from '../../overview/OverviewItem'
import { OverviewSection } from '../../overview/OverviewSection'
import { withLegalEntityOrLife } from '../../wrappers/withLegalEntityOrLife'
import { BirthOrDeathDate } from './BirthOrDeathDate'
import { MemberIcon } from './MemberIcon'
import { ParticipantSectionLayout } from './ParticipantSectionLayout'

type Props = PropsWithChildren

const ParticipantSectionInternal = ({ children }: Props) => {
  const translate = useTranslate()
  const { ownerId } = useHook('routing.general.useEntityParams')()
  const RelationshipInfo = useComponent(
    'pages.commitment.general.RelationshipInfo',
  )
  const NameAndDeathStatus = useComponent(
    'pages.commitment.general.NameAndDeathStatus',
  )

  return (
    <ParticipantSectionLayout
      MemberIcon={MemberIcon}
      NameAndDeathStatus={NameAndDeathStatus}
    >
      <OverviewSection>
        <OverviewItem
          iconName="Identification"
          title={translate('participantSection.ssn')}
          hasCopyButton
        >
          <IdToPerson id={ownerId} format="externalId" link="never" />
        </OverviewItem>
        <BirthOrDeathDate />
        <RelationshipInfo />
      </OverviewSection>
      {children}
    </ParticipantSectionLayout>
  )
}

export const ParticipantSection = withLegalEntityOrLife(
  ParticipantSectionInternal,
)
